import { render, staticRenderFns } from "./rules_user_protocal.vue?vue&type=template&id=9ef1f380&scoped=true&"
import script from "./rules_user_protocal.vue?vue&type=script&lang=js&"
export * from "./rules_user_protocal.vue?vue&type=script&lang=js&"
import style0 from "./rules_user_protocal.vue?vue&type=style&index=0&id=9ef1f380&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9ef1f380",
  null
  
)

export default component.exports